module.exports = __webpack_public_path__ + "static/grafika13-ca4d82661a2c00410275a92e0d74647c.png";